import React, { useState, useEffect } from 'react';
import { db } from '../firebase-config';
import { collection, onSnapshot, query, orderBy } from 'firebase/firestore';
import './Dashboard.css';

const Dashboard = () => {
  const [stats, setStats] = useState({ total: 0, today: 0 });
  const [todayLogs, setTodayLogs] = useState([]);

  useEffect(() => {
    const q = query(collection(db, 'attendance'), orderBy('createdAt', 'desc'));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const allData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      const todayStr = new Date().toLocaleDateString();

      // FILTER: Only count logs that match TODAY'S date string
      const filteredToday = allData.filter(log => log.dateLabel === todayStr);

      setStats({
        total: allData.length,      // Shows the 83 (History)
        today: filteredToday.length // Shows only today's scans
      });
      setTodayLogs(filteredToday);
    });

    return () => unsubscribe();
  }, []);

  return (
    <div className="dashboard-container">
      <div className="stats-grid">
        <div className="stat-card">
          <h3>Total History</h3>
          <p className="number">{stats.total}</p>
        </div>
        <div className="stat-card highlight">
          <h3>Present Today</h3>
          <p className="number">{stats.today}</p>
        </div>
      </div>
      
      <h3>Today's Activity</h3>
      <table className="attendance-table">
        <thead>
          <tr><th>Time</th><th>Status</th></tr>
        </thead>
        <tbody>
          {todayLogs.map(log => (
            <tr key={log.id}>
              <td>{new Date(log.fullTimestamp).toLocaleTimeString()}</td>
              <td>{log.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Dashboard;